<template>
  <div>
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="!exibirGrafico"
      :style="styleObject"
      class="text-center"
    >
      Não há dados disponíveis
    </div>
    <div v-else>
      <canvas
        id="chartColetaLeite"
        width="150"
        height="70"
      />
      <div
        v-if="exibirLegenda"
        id="legendaComparativo"
        class="text-center px-3"
      >
        <v-row
          align="center"
          class="ma-0"
        >
          <span class="totalizador">
            Leite coletado entre {{ formatDiaMesAno(primeiroDia) }} e {{ formatDiaMesAno(ultimoDia) }}
          </span>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
  import Chart from 'chart.js'
  import EntregaLeite from '../../../../services/entregaleite'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardLeiteColetado',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      empresaSelect: [],
      linhaSelect: [],
      produtorSelect: [],
      loading: false,
      error: null,
      exibirLegenda: false,
      exibirGrafico: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart1: {},
      styleObjectvalorRestante: {
        color: '#ed934f',
      },
      montarGrafico: true,
      text: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },
    methods: {
      formatDiaMesAno (date) {
        if (!date) return null

        date = date.substr(0, 10)

        const [year, month, day] = date.split('-')
        var result = `${day}/${month}/${year}`

        if (result === '30/12/1899') {
          return ''
        } else {
          return result
        }
      },
      handleUpdateDados (primeiroDia, dataFinal, select, produtor, linhasleite) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.produtorSelect = produtor
        this.linhaSelect = linhasleite

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await EntregaLeite.showLeiteColetado(this.primeiroDia, this.ultimoDia, this.empresaSelect, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          this.exibirGrafico = resposta.data.exibirGrafico
          if (resposta.data.status && resposta.data.exibirGrafico) {
            this.$nextTick(() => {
              setTimeout(() => {
                const ctx = document.getElementById('chartColetaLeite')?.getContext('2d')
                if (ctx) {
                  this.myChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                      labels: resposta.data.coletas.datacoleta,
                      datasets: [
                        {
                          label: 'Coleta de leite',
                          data: resposta.data.coletas.qtdleite,
                          backgroundColor: '#4780b8',
                          order: 1,
                        },
                      ],
                    },
                    options: {
                      scales: {
                        y: {
                          beginAtZero: true,
                        },
                        xAxes: [{
                          gridLines: {
                            display: false,
                          },
                        }],
                        yAxes: [{
                          ticks: {
                            min: 0,
                          },
                          gridLines: {
                            display: false,
                          },
                          display: false,
                        }],
                      },
                      low: 50,
                      high: 5,
                      legend: {
                        display: false,
                      },
                      tooltips: {
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { maximumFractionDigits: 0 })
                            return value + ' Litros'
                          },
                          title: (tooltipItem) => {
                            return tooltipItem[0].xLabel
                          },
                        },
                      },
                    },
                  })
                } else {
                  console.error('Elemento canvas não encontrado.')
                }
              }, 0)
            })
          } else if (resposta.data.msg === 'Não há dados para comparar com o filtro selecionado') {
            this.text = resposta.data.text
            this.exibirGrafico = false
            if (this.myChart.data) {
              this.myChart.destroy()
            }
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          console.error('erro', e)
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
    </script>

    <style lang="sass">
      #myChart7
        margin-top: -5rem

      #legendaComparativo
        font-size: 12px
        margin: 1rem 0 0 1rem
    </style>

    <style scoped>
      .custom-loader {
        animation: loader 1s infinite;
        display: flex;
        @-moz-keyframes loader
          from
            transform: rotate(0)

          to
            transform: rotate(360deg)

        @-webkit-keyframes loader
          from
            transform: rotate(0)

          to
            transform: rotate(360deg)

        @-o-keyframes loader
          from
            transform: rotate(0)

          to
            transform: rotate(360deg)

        @keyframes loader
          from
            transform: rotate(0)

          to
            transform: rotate(360deg)
      }

      @media screen
      and (min-device-width : 320px)
      and (max-device-width : 560px) {
        #myChart7 {
          margin: -5rem 0 0 0;
          width: 400px !important;
          height: 175px !important;
        }

        #legendaComparativo {
          font-size: 9px;
          margin: 0 0 0 0
        }
      }

      @media screen
      and (min-width : 600px)
      and (max-width : 1000px)
      and (-webkit-min-device-pixel-ratio: 1) {
        #myChart7 {
          margin: -3rem 0 0 6rem;
          width: 780px !important;
          height: 364px !important;
        }

        #legendaComparativo {
          font-size: 12px;
          margin: 1rem 0 0 7rem;
        }
      }
      .totalizador{
          font-weight: bold;
        }
    </style>
